<template>
   <div class="summary clearfix" :class="`tx-${getClass}`">
      <div class="dot l" :class="`bg-${getClass}`"></div>
      <div class="txt l" >
         {{getText}}
      </div>
   </div>
</template>

<script>
export default {
   name: "Status",
   props: {
      status: {
         type: String,
         default: 'created'
      }
   },
   computed: {
      getText() {
         switch (this.status) {
            case 'created': return 'Created';
            case 'updated': return 'Updated';
            case 'create_pending': return 'Create Pending';
            case 'update_pending': return 'Update Pending';
            case 'delete_pending': return 'Delete Pending';
            case 'verified': return 'Verified';
            case 'inactive': return 'In-Active';
            default: return this.status;
         }
      },
      getClass() {
         switch (this.status) {
            case 'created': return 'success';
            case 'updated': return 'success';
            case 'verified': return 'success';
            case 'create_pending': return 'primary';
            case 'update_pending': return 'warning';
            case 'delete_pending': return 'danger';
            case 'inactive': return 'danger';
            default: return this.status;
         }
      },
   }
}
</script>

<style lang="scss">
   .summary{
      .dot{
         width: 7px;
         height: 7px;
         margin: 5px 5px 0 0;
         border-radius: 50%;
      }
      .txt{
         font-size: 12px;
         font-weight: $weight-bold;
      }
   }
</style>